import React, {useCallback} from 'react'
import styles from './CardImage.module.scss'

const boxAnimation = {
    hidden: {
        scale: 0,
        opacity: 0,
    },
    visible: {
        scale: 1,
        opacity: 1,
        transition: { duration: .7}
    } 
}


export const CardImage = ({item, isImageOpen, index, arr}) => {

    const cardClick = useCallback(() => {
        isImageOpen(index, arr)
    }, [index, isImageOpen, arr])

    return (
        <li 
            className={styles.item}  
            onClick={cardClick}
            initial='hidden'
            whileInView='visible'
            viewport={{amount: 0.05, once: true}}
            variants={boxAnimation} 
            >
            <img className={styles.image} src={item.image} alt={item.title}/>
        </li>
    )
}